<template>
  <div class="country-list">
    <button
      class="country-list_item"
      v-for="(countryName, countryCode) in availableCountries"
      :key="countryCode"
      :class="[
        'country-list_item__' + countryCode.toLowerCase(),
        currentCountry === countryCode && 'country-list_item__current'
      ]"
      @click="changeCountry(countryCode)"
    >
      {{ $t(countryName[0]) }}
    </button>
  </div>
</template>

<script>
import { Vue, Component, Emit } from 'vue-property-decorator'
import { State } from 'vuex-class'

import { AVAILABLE_COUNTRIES } from '@/constants'

@Component
class RegionSelector extends Vue {
  @State('country') currentCountry

  get availableCountries () {
    return AVAILABLE_COUNTRIES
  }

  @Emit('selected')
  changeCountry (countryCode) {
    this.$store.dispatch('changeCountry', countryCode)
  }
}

export default RegionSelector
</script>

<style lang="scss">
$countries: ru by kz;
$country-list_hover-color: #fff;
$country-list_border-color: #fff;

.country-list {
  margin: 20px 0 0;

  &_item {
    @include button-normalize;
    background: transparent;
    border: 1px solid transparent;
    border-radius: 16px;
    color: #a1a1a1;
    cursor: pointer;
    display: inline-block;
    font-size: 14px;
    font-weight: 400;
    margin: 0 14px 23px;
    padding: 9px 23px 8px 49px;
    position: relative;
    text-decoration: none;
    transition: color $duration,
                border-color $duration;
    user-select: none;
    @include media_tablet {
      margin: 0 20px;
    }
    @include media_desktop {
      margin: 0 25px;
    }

    &:hover {
      border-color: $country-list_border-color;
      color: $country-list_hover-color;
    }
    &:before {
      background-repeat: no-repeat;
      content: "";
      height: 11px;
      width: 17px;
      position: absolute;
      top: 11px;
      left: 23px;
    }
    @each $country in $countries {
      &__#{$country}:before {
        background-image: url("./images/flag_#{$country}.png");
      }
    }
    &__current {
      border-color: $country-list_border-color;
      color: $country-list_hover-color;
    }
  }
}
</style>
